import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {selectProductData} from 'modules/product-card/selectors';
import {useMemo} from 'react';

export const useProductImagesAltText = () => {
    const productData = useAppSelector(selectProductData);
    const {id, catalogRusName, description, price, title} = productData || {};

    return useMemo(() => {
        const seoPrice = price ? `цена ${price.discount.price} рублей` : '';
        const seoArticle = `(${id})`;

        return [title, seoArticle, description, catalogRusName, seoPrice].join(', ');
    }, [id, catalogRusName, description, price, title]);
};
